module.exports = __webpack_public_path__ + "img/legume-edamame-190x100.24d0a796.jpg";